import { assessmentNames } from "../lib/assessment";
import type { ReactNode } from "react";
import { Icon, type IconName } from "../components/Icon";

/**
 * Cabecera común de las vistas de pantalla completa: un rótulo con el código
 * (U2, M4, EA), el título grande y una fila de datos de contexto. Es lo que
 * convierte una pila de bloques en una vista con nombre propio.
 */

export interface PresetChip {
  icon: IconName;
  label: string;
}

export interface PresetShellProps {
  eyebrow: string | null;
  title: string;
  lead?: string | null;
  chips?: PresetChip[];
  children: ReactNode;
}

export function PresetShell({ eyebrow, title, lead, chips = [], children }: PresetShellProps) {
  return (
    <article className="preset">
      <header className="preset__hero">
        {eyebrow ? <span className="preset__eyebrow">{assessmentNames(eyebrow)}</span> : null}
        <h1 className="preset__title">{assessmentNames(title)}</h1>
        {lead ? <p className="preset__lead">{assessmentNames(lead)}</p> : null}
        {chips.length > 0 ? (
          <ul className="preset__chips">
            {chips.map((chip, index) => (
              <li key={`${chip.label}-${index}`} className="preset__chip">
                <Icon name={chip.icon} size="0.75rem" />
                {assessmentNames(chip.label)}
              </li>
            ))}
          </ul>
        ) : null}
      </header>

      <div className="preset__body">{children}</div>
    </article>
  );
}

export default PresetShell;
